import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/staking/";

export const stakingService = {
  async list(filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(path + "admin-find?" + searchParams.toString());
  },

  async view(id) {
    return await axios.get(path + id);
  },

  async detail(id) {
    return await axios.get(`${path}${id}/detail`);
  },

  async update(id, payload) {
    return await axios.patch(path + id, payload);
  },

  async updateAvaiableReward(id, chainId) {
    return await axios.put(`${path}${id}/avaliable-reward?chainId=${chainId}`);
  },

  async updateSpecialFees(id, specialFees) {
    return await axios.patch(`${path}${id}/special-fees`, {
      specialFees,
    });
  },

  async syncBoosterDetail(address) {
    return axios.patch(`${path}${address}/sync-booster`);
  },

  async calculateAPR(id) {
    return axios.post(`${path}${id}/calculate-apr`);
  },

  async createNormal(payload) {
    return await axios.post(path, payload);
  },

  async createSoft(payload) {
    return await axios.post(`${path}soft`, payload);
  },

  async remove(id) {
    return await axios.delete(path + id);
  },
};
